import React, { useState } from 'react';
import PageHero from './PageHero';
import { Mail, GraduationCap, X, ChevronRight, Award, Quote, Users } from 'lucide-react';
import heroImg from '../assets/Banner-GMIS Students.png';
import gopeSamtani from '../assets/Gope Samtani.png';

const LEADERSHIP_MEMBERS = [
  {
    id: 'principal',
    name: 'Mr. A. P. Singh',
    role: 'Principal & Head of School',
    category: 'leadership',
    categoryLabel: 'School Leadership Team',
    qualifications: 'M.Sc., M.Ed., IB Head of School Certified',
    experience: '28+ Years in International Education',
    image: gopeSamtani,
    quote: 'Education is not merely the transmission of knowledge, but the cultivation of character, compassion, and critical inquiry.',
    bio: 'Mr. A. P. Singh has served the GMIS community for over two decades with visionary leadership. Under his guidance, the school has achieved full IB Continuum status across PYP, MYP, DP, and CP streams while nurturing a vibrant, multicultural family of students from over 50 nations. He is passionate about holistic education, community service, and preparing students to excel in top global universities.',
  },
  {
    id: 'trustee-1',
    name: 'Board of Trustees (GSL)',
    role: 'Governing Council & Trust Leadership',
    category: 'board',
    categoryLabel: 'Board of Trustees',
    qualifications: 'Yayasan Gandhi Memorial Intercontinental',
    experience: 'Stewards of GMIS Heritage since 1950',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=600&q=80',
    quote: 'Upholding Mahatma Gandhi’s enduring values of truth, peace, non-violence, and service to society.',
    bio: 'The Board of Trustees provides strategic governance, institutional stewardship, and fiduciary oversight to ensure GMIS remains true to its founding mission established in 1950. The Trustees work closely with the administration to invest in world-class campus facilities, faculty development, and community scholarships.',
  },
  {
    id: 'dp-coordinator',
    name: 'Dr. Priya Sharma',
    role: 'IB Diploma Programme (DP) Coordinator',
    category: 'academic',
    categoryLabel: 'Academic Coordinators',
    qualifications: 'Ph.D. in Education, M.A. English Literature',
    experience: '18 Years IB Teaching & Examining Experience',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=600&q=80',
    quote: 'Empowering senior students to question assumptions, bridge disciplines, and lead with empathy.',
    bio: 'Dr. Priya oversees the senior secondary academic curriculum, guiding students through the rigorous IB Diploma and Career-related pathways. She also leads university admissions counseling, having mentored hundreds of graduates into Ivy League, Russell Group, and leading universities worldwide.',
  },
  {
    id: 'myp-coordinator',
    name: 'Mr. David Reynolds',
    role: 'IB Middle Years Programme (MYP) Coordinator',
    category: 'academic',
    categoryLabel: 'Academic Coordinators',
    qualifications: 'M.Ed. Curriculum Design, B.Sc. Mathematics',
    experience: '15 Years in International Schools',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=600&q=80',
    quote: 'The middle school years are transformative. We cultivate curiosity and independent problem-solving.',
    bio: 'Mr. Reynolds directs the MYP framework for Grades 6 through 10, championing interdisciplinary learning, the personal project exhibition, and mathematical literacy. He works with faculty to ensure seamless progression between primary inquiry and senior diploma rigor.',
  },
  {
    id: 'pyp-coordinator',
    name: 'Ms. Sarah Kurniawan',
    role: 'IB Primary Years Programme (PYP) Coordinator',
    category: 'academic',
    categoryLabel: 'Academic Coordinators',
    qualifications: 'B.Ed. Early Childhood, IB Workshop Leader',
    experience: '14 Years Primary Education Specialist',
    image: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?auto=format&fit=crop&w=600&q=80',
    quote: 'When children own their learning through inquiry, their wonder and creativity know no limits.',
    bio: 'Ms. Sarah leads the early childhood and primary division. She fosters a dynamic play-and-inquiry learning environment where young learners develop bilingual communication, foundational literacy, numeracy, and social-emotional resilience.',
  },
  {
    id: 'cambridge-head',
    name: 'Mr. Rajesh Menon',
    role: 'Cambridge IGCSE & Exam Officer',
    category: 'academic',
    categoryLabel: 'Academic Coordinators',
    qualifications: 'M.Sc. Physics, Cambridge Certified Assessment Specialist',
    experience: '20 Years in Cambridge Examinations',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=600&q=80',
    quote: 'Academic precision, rigorous assessment, and scientific thinking form the foundation of achievement.',
    bio: 'Mr. Menon supervises the Cambridge Secondary Checkpoints and IGCSE examination administration. His deep expertise ensures strict examination integrity, high academic attainment, and personalized academic coaching for secondary candidates.',
  },
  {
    id: 'stem-head',
    name: 'Ms. Elena Rostova',
    role: 'Head of Sciences & Innovation Labs',
    category: 'faculty',
    categoryLabel: 'Faculty Leads',
    qualifications: 'M.Sc. Biochemistry, B.Sc. Chemistry',
    experience: '12 Years International STEM Educator',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=600&q=80',
    quote: 'Hands-on experimentation turns abstract formulas into real discoveries that impact humanity.',
    bio: 'Ms. Rostova oversees biology, chemistry, and physics laboratories across Middle and Senior schools. She mentors students in the annual science fair, robotics club, and experimental research competitions across Southeast Asia.',
  },
  {
    id: 'arts-head',
    name: 'Mr. Kenneth Wijaya',
    role: 'Head of Performing Arts & Drama',
    category: 'faculty',
    categoryLabel: 'Faculty Leads',
    qualifications: 'B.A. Performing Arts, Royal Academy Certified',
    experience: '16 Years Director of School Theatre',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=600&q=80',
    quote: 'The stage gives every student a voice, building confidence and emotional expression that lasts a lifetime.',
    bio: 'Mr. Wijaya directs the annual GMIS Musical & Play Production, school choir, and theatrical drama workshops. He collaborates across languages and musical traditions to stage world-class productions in our 500-seat auditorium.',
  },
  {
    id: 'counselor',
    name: 'Ms. Ananya Roy',
    role: 'Head of Well-being & College Counselor',
    category: 'faculty',
    categoryLabel: 'Faculty Leads',
    qualifications: 'M.A. Counseling Psychology, Member IC3',
    experience: '11 Years Student Pastoral Care',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=600&q=80',
    quote: 'Every student deserves to feel heard, valued, and empowered to chart their own unique life journey.',
    bio: 'Ms. Roy leads our comprehensive safeguarding, pastoral counseling, and university placement office. She conducts one-on-one advising sessions for students and parents, organizing university fairs and career orientation workshops.',
  },
];

const CATEGORIES = [
  { id: 'all', label: 'All Leadership & Faculty' },
  { id: 'leadership', label: 'School Leadership' },
  { id: 'board', label: 'Board of Trustees' },
  { id: 'academic', label: 'Academic Coordinators' },
  { id: 'faculty', label: 'Faculty Department Leads' },
];

export default function LeadershipFacultyPage({ setPage, t }) {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedMember, setSelectedMember] = useState(null);

  const filteredMembers =
    activeCategory === 'all'
      ? LEADERSHIP_MEMBERS
      : LEADERSHIP_MEMBERS.filter((m) => m.category === activeCategory);

  const navCategory = t?.nav?.[1]?.label || "About Us";
  const homeLabel = t?.nav?.[0]?.label || "Home";

  return (
    <div className="w-full bg-[#f8f9fa] min-h-screen text-ink">
      {/* ── Page Hero ──────────────────────────────────────────────────────── */}
      <PageHero
        title="School Leadership & Faculty"
        eyebrow={navCategory}
        subtitle="Meet the educators and administrators guiding Gandhi Memorial Intercontinental School with experience, vision, and a commitment to student success."
        breadcrumbs={[homeLabel, navCategory, 'Leadership & Faculty']}
        bgImage={heroImg}
      />

      <div className="max-w-[1240px] mx-auto px-6 lg:px-[60px] py-16 lg:py-24">

        {/* ── Section 1: Welcome from the Head of School ───────────────────── */}
        <section className="mb-20">
          <div className="bg-white rounded-3xl border border-line p-8 lg:p-14 shadow-[0_10px_40px_rgba(14,36,62,0.05)]">
            <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
              <div className="lg:col-span-5 flex flex-col items-center text-center">
                <div className="relative w-64 h-64 lg:w-72 lg:h-72 rounded-2xl overflow-hidden shadow-2xl border-4 border-white mb-6">
                  <img
                    src={gopeSamtani}
                    alt="Head of School"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
                </div>
                <h3 className="text-xl font-heading font-bold text-navy">
                  Mr. A. P. Singh
                </h3>
                <p className="text-xs font-semibold text-gold uppercase tracking-wider mt-1">
                  Principal & Head of School
                </p>
                <div className="inline-flex items-center gap-1.5 mt-3 text-xs text-ink/60">
                  <GraduationCap className="w-4 h-4 text-gold-ink" />
                  <span>M.Sc., M.Ed., IB Head of School Certified</span>
                </div>
              </div>

              <div className="lg:col-span-7 flex flex-col justify-center">
                <div className="inline-flex items-center gap-2 mb-4 px-3.5 py-1 rounded-full border border-gold/30 bg-gold/10 w-fit">
                  <Quote className="w-3.5 h-3.5 text-gold-ink" />
                  <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">Welcome Message</span>
                </div>
                <h2 className="text-2xl lg:text-3xl font-heading font-bold text-navy uppercase tracking-tight mb-5 leading-snug">
                  Nurturing Inquiring Minds, Global Hearts & Enduring Values
                </h2>
                <div className="space-y-4 text-ink/80 text-[15.5px] leading-relaxed">
                  <p>
                    At GMIS Jakarta, our leadership team works in harmonious partnership with our dedicated faculty, trustees, and families to foster an inclusive school environment where every student is known, encouraged, and challenged.
                  </p>
                  <p>
                    Rooted in Gandhian philosophy and enriched by the world’s most respected international curricula — the International Baccalaureate Continuum and Cambridge Assessment — we equip students to excel academically while embracing cultural humility and social responsibility.
                  </p>
                </div>
                <div className="mt-8 pt-6 border-t border-line flex items-center justify-between">
                  <div>
                    <p className="font-heading font-bold text-navy text-sm uppercase tracking-wide">Gandhi Memorial Intercontinental School</p>
                    <p className="text-xs text-ink/60">Kemayoran, Jakarta · Founded 1950</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      if (setPage) setPage('about');
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    className="inline-flex items-center gap-2 text-xs font-bold text-navy hover:text-gold transition-colors duration-200 cursor-pointer"
                  >
                    <span>Read GMIS History</span>
                    <ChevronRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── Section 2: Category Filter Tabs ──────────────────────────────── */}
        <section className="mb-12">
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3">
            {CATEGORIES.map((cat) => (
              <button
                key={cat.id}
                type="button"
                onClick={() => setActiveCategory(cat.id)}
                className={`px-5 py-2.5 rounded-full text-xs font-bold uppercase tracking-wider transition-all duration-200 cursor-pointer border ${
                  activeCategory === cat.id
                    ? 'bg-navy-deep text-gold border-navy-deep shadow-md'
                    : 'bg-white text-ink/75 border-line hover:border-gold hover:text-navy'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </section>

        {/* ── Section 3: Faculty & Leadership Grid ─────────────────────────── */}
        <section className="mb-20">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredMembers.map((member) => (
              <div
                key={member.id}
                className="bg-white rounded-2xl border border-line overflow-hidden shadow-[0_8px_30px_rgba(14,36,62,0.04)] hover:shadow-[0_16px_40px_rgba(14,36,62,0.1)] transition-all duration-300 flex flex-col justify-between group hover:-translate-y-1.5"
              >
                <div>
                  <div className="h-64 w-full overflow-hidden relative bg-navy/5">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 rounded-full bg-navy-deep/85 backdrop-blur-sm text-gold text-[10.5px] font-bold tracking-wider uppercase">
                        {member.categoryLabel}
                      </span>
                    </div>
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-heading font-bold text-navy mb-1 group-hover:text-gold transition-colors">
                      {member.name}
                    </h3>
                    <p className="text-xs font-semibold text-gold mb-3">
                      {member.role}
                    </p>
                    <p className="text-xs text-ink/60 mb-3 flex items-center gap-1.5 font-mono">
                      <GraduationCap className="w-3.5 h-3.5 text-navy/50 shrink-0" />
                      <span className="truncate">{member.qualifications}</span>
                    </p>
                    <p className="text-xs text-ink/75 leading-relaxed line-clamp-3">
                      {member.bio}
                    </p>
                  </div>
                </div>

                <div className="px-6 pb-6 pt-2 border-t border-line/60 flex items-center justify-between">
                  <button
                    type="button"
                    onClick={() => setSelectedMember(member)}
                    className="text-xs font-bold text-navy hover:text-gold transition-colors inline-flex items-center gap-1 cursor-pointer"
                  >
                    <span>Read Full Profile</span>
                    <ChevronRight className="w-3.5 h-3.5" />
                  </button>
                  <span className="text-[11px] text-ink/50 font-medium">
                    {member.experience}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── Section 4: Governance & Standards Callout ────────────────────── */}
        <section className="bg-white rounded-3xl border border-line p-8 lg:p-12 mb-20 shadow-sm">
          <div className="grid md:grid-cols-3 gap-8 text-center md:text-left">
            <div className="flex flex-col gap-3">
              <div className="w-12 h-12 rounded-xl bg-gold/15 text-gold-ink flex items-center justify-center">
                <Users className="w-6 h-6" />
              </div>
              <h4 className="font-heading font-bold text-navy text-lg uppercase">
                International Faculty Body
              </h4>
              <p className="text-sm text-ink/70 leading-relaxed">
                Educators recruited globally, holding advanced master's and doctoral degrees with extensive IB and Cambridge certification.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <div className="w-12 h-12 rounded-xl bg-gold/15 text-gold-ink flex items-center justify-center">
                <Award className="w-6 h-6" />
              </div>
              <h4 className="font-heading font-bold text-navy text-lg uppercase">
                Continuous Professional Learning
              </h4>
              <p className="text-sm text-ink/70 leading-relaxed">
                Ongoing pedagogical training with the International Baccalaureate Organization, Cambridge International, and leading global institutes.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <div className="w-12 h-12 rounded-xl bg-gold/15 text-gold-ink flex items-center justify-center">
                <Quote className="w-6 h-6" />
              </div>
              <h4 className="font-heading font-bold text-navy text-lg uppercase">
                Child Safeguarding Commitment
              </h4>
              <p className="text-sm text-ink/70 leading-relaxed">
                Rigorous CIS-aligned safeguarding, background checks, and proactive student wellbeing policies across all divisions.
              </p>
            </div>
          </div>
        </section>

        {/* ── Section 5: CTA Strip ─────────────────────────────────────────── */}
        <section className="bg-navy-deep text-white rounded-3xl p-10 lg:p-14 text-center relative overflow-hidden shadow-2xl">
          <div className="absolute inset-0 bg-gradient-to-r from-gold/10 via-transparent to-navy/40 pointer-events-none" />
          <div className="relative z-10 max-w-2xl mx-auto">
            <h2 className="text-2xl lg:text-3xl font-heading font-bold text-white uppercase tracking-tight mb-4">
              Connect with Our Leadership Team
            </h2>
            <p className="text-white/80 text-base leading-relaxed mb-8">
              We welcome prospective families to consult with our academic coordinators and discover how our faculty empowers students to flourish.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <button
                type="button"
                onClick={() => {
                  if (setPage) setPage('schedule-visit');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="px-8 py-3.5 rounded-full bg-gold text-navy-deep font-bold text-xs uppercase tracking-widest hover:brightness-110 transition-all shadow-md cursor-pointer border-0"
              >
                Schedule a Visit
              </button>
              <button
                type="button"
                onClick={() => {
                  if (setPage) setPage('contact');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="px-8 py-3.5 rounded-full bg-white/10 text-white font-bold text-xs uppercase tracking-widest hover:bg-white/20 transition-all border border-white/20 cursor-pointer"
              >
                Contact Admissions
              </button>
            </div>
          </div>
        </section>

      </div>

      {/* ── Profile Bio Modal ──────────────────────────────────────────────── */}
      {selectedMember && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-navy-deep/75 backdrop-blur-sm animate-fadeIn">
          <div className="bg-white rounded-3xl max-w-2xl w-full p-8 lg:p-10 relative shadow-2xl border border-line max-h-[90vh] overflow-y-auto">
            <button
              type="button"
              onClick={() => setSelectedMember(null)}
              className="absolute top-6 right-6 w-10 h-10 rounded-full bg-navy/5 hover:bg-gold/20 text-navy flex items-center justify-center transition-colors cursor-pointer border-0"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 mb-6">
              <img
                src={selectedMember.image}
                alt={selectedMember.name}
                className="w-28 h-28 rounded-2xl object-cover shadow-md shrink-0 border-2 border-gold/30"
              />
              <div className="text-center sm:text-left">
                <span className="px-3 py-1 rounded-full bg-gold/10 text-gold-ink text-[11px] font-bold tracking-wider uppercase inline-block mb-2">
                  {selectedMember.categoryLabel}
                </span>
                <h3 className="text-2xl font-heading font-bold text-navy">
                  {selectedMember.name}
                </h3>
                <p className="text-sm font-semibold text-gold mt-0.5">
                  {selectedMember.role}
                </p>
                <p className="text-xs text-ink/60 mt-1 font-mono">
                  {selectedMember.qualifications}
                </p>
              </div>
            </div>

            {selectedMember.quote && (
              <div className="p-4 rounded-xl bg-paper border border-gold/20 mb-6 italic text-sm text-navy font-medium flex items-start gap-3">
                <Quote className="w-4 h-4 text-gold shrink-0 mt-0.5" />
                <span>"{selectedMember.quote}"</span>
              </div>
            )}

            <div className="space-y-3 text-sm text-ink/80 leading-relaxed mb-8">
              <p>{selectedMember.bio}</p>
            </div>

            <div className="pt-6 border-t border-line flex flex-wrap items-center justify-between gap-4">
              <div className="text-xs text-ink/60">
                <span>Experience: </span>
                <strong className="text-navy">{selectedMember.experience}</strong>
              </div>
              <button
                type="button"
                onClick={() => {
                  setSelectedMember(null);
                  if (setPage) setPage('contact');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="px-6 py-2.5 rounded-full bg-navy-deep text-gold font-bold text-xs uppercase tracking-wider hover:bg-navy transition-colors cursor-pointer border-0"
              >
                Inquire with School
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
